import axios from "axios";
import { API_GUEST } from "../../config";

// Create an axios instance for guest services
const axiosGuestInstance = axios.create({
  baseURL: API_GUEST,
  withCredentials: false,
});

// Function to call the guest API
const callGuestAPI = async (options) => {
  try {
    const { data } = await axiosGuestInstance(options);
    return data;
  } catch (error) {
    if (error.response) {
      throw new Error(
        error.response.data.message
          ? error.response.data.message
          : error.response.data.error
      );
    } else if (error.request) {
      throw new Error("Could not connect to server");
    } else {
      throw new Error(error.message);
    }
  }
};

export { callGuestAPI };
